import React from 'react';

import { CustomModal } from '~components/commons/CustomModal/CustomModal';

import styles from './BillingSuspensionBlockingModal.module.scss';

import './BillingSuspensionBlockingModal.scss';

interface BaseBillingSuspensionModalProps {
	children: React.ReactNode;
	title: string;
	submitText: string;
	onSubmit: () => void;
	eyebrow?: string;
	/** Omit to make it undismissable: no close button, and the backdrop is static. */
	onDismiss?: () => void;
	titleIcon?: React.FunctionComponent<{ className?: string }>;
}

export const BaseBillingSuspensionModal = ({
	children,
	title,
	submitText,
	onSubmit,
	eyebrow,
	onDismiss,
	titleIcon,
}: BaseBillingSuspensionModalProps): React.JSX.Element => (
	<CustomModal
		isOpen
		subtitle={eyebrow}
		subTitleClassName={styles.eyebrow}
		titleIcon={titleIcon}
		title={title}
		onClose={onDismiss}
		onSubmit={onSubmit}
		submitText={submitText}
		className="billing-suspension-modal"
	>
		<p className="blocking-modal-text">{children}</p>
	</CustomModal>
);
